import { VotesStateType } from './ContentSurvey';
import { __t } from '../../i18n';
import { Flex, Text, Button } from '../../styles';
import Avatar from '../../styles/Avatar';

type VoteSummaryProps = {
  state: VotesStateType,
  onClear: () => void,
  onConfirm: () => void,
};

export default function VoteSummary({ state, onClear, onConfirm }: VoteSummaryProps) {
  return (
    <>
      <Flex justify="center">
        <img width="92" height="80" src="/images/vote_summary_star.svg" alt=""/>
      </Flex>
      <Text align="center" mt={2} mb={6}>{__t('survey.summary_title')}</Text>
      <Flex justify="center" style={{ flexWrap: 'wrap' }}>
        {Object.entries(state).map(([key, { point, img }]) => (
          <Flex mx={1} key={key} align="center" direction="column"
            style={{ opacity: point === 0 ? '.34' : '1' }}
          >
            <Avatar size="3rem" image={img || undefined} />
            <Text variant="body2" mt={1}>{point === 0 ? '-' : point}</Text>
          </Flex>
        ))}
      </Flex>

      <Flex direction={{ sm: 'row' }} justify="space-between" mt={5}>
        <Button
          variant="primaryB"
          fullWidth
          ml={{ xs: 2, sm: 3 }}
          onClick={() => onConfirm()}
        >
          {__t('common.submit')}
        </Button>
        <Button
          variant="secondary"
          fullWidth
          onClick={() => onClear()}
        >
          {__t('common.clear')}
        </Button>
      </Flex>
    </>
  );
}
